import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, AlertForm, AlertRedirect, MascaraCNPJ } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  TextoDescPesquisa,
  FormPesquisa,
  DoisCampos,
  CampoFormBusca,
  CampoFormCadastro,
  BotaoEnviarPesquisa,
  BtIcoBuscar,
  DescCampo,
  ModalEvento,
  BgModal,
  ItemListaBusca,
  ClienteProdutoSelecionado,
  BtVoltar,
  CheckBox
} from './Estilos'

import IcoBusca from './Images/ico_search_branco.png'
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function Merchandising(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ CPFUser, setCPFUser ] = useState(localStorage.getItem("c_cpf"));

  const [ MostraResultados, setMostraResultados ] = useState(false);
  const [ DadosClienteFlatlist, setDadosClienteFlatlist ] = useState([]);
  const [ PrecoPao, setPrecoPao ] = useState(0);
  const [ ClienteSelecionado, setClienteSelecionado ] = useState(false);
  const [ TextoAguarde, setTextoAguarde ] = useState(false);
  const [ CarregandoBusca, setCarregandoBusca ] = useState(true);
  const [ ClienteNome, setClienteNome ] = useState("");
  const [ ClienteCPNJ, setClienteCPNJ ] = useState("");
  const [ ClienteSAP, setClienteSAP ] = useState("");
  const [ ClienteID, setClienteID ] = useState("");
  const [ RealizouCompra, setRealizouCompra ] = useState('');
  const [ PerguntaPesquisa, setPerguntaPesquisa ] = useState(0);
  const [ RespostaPesquisa, setRespostaPesquisa ] = useState(0);
  const [ ListaPerguntas, setListaPerguntas ] = useState([]);
  const [ ListarPerguntasPesquisaCompleta, setListarPerguntasPesquisaCompleta ] = useState([]);
  const [ CheckBoxPotencial, setCheckBoxPotencial ] = useState(false);

  const [Estados, setEstados] = useState([]);
  const [DadosMerchandising, setDadosMerchandising] = useState([]);


  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Merchandising");
        ListarUF()
    }    
  }, []);

  const onSubmit = async (data, e) => {

    var valida = false;
    
    if(data.c_bandeira == undefined || data.c_bandeira.length < 3){
      AlertForm('Você precisa digitar no mínimo 3 dígitos da bandeira que deseja filtrar');
      e.preventDefault();
      return false
    }
    
    if(data.c_municipio == undefined || data.c_municipio.length < 3){
      AlertForm('Você precisa digitar no mínimo 3 dígitos do município que deseja filtrar');
      e.preventDefault();
      return false
    }


      // console.log(
      //   'passou',
      //   data.c_municipio,
      //   data.c_bandeira,
      //   data.c_cnpj ==! undefined ? data.c_cnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','').replaceAll('_','') : undefined,
      //   data.c_uf
      // );
      // return

      setTextoAguarde(true);
      setMostraResultados(true);

      var myHeaders = new Headers();
      myHeaders.append("Authorization", "bearer " + Token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "bandeira": data.c_bandeira,
        "municipio": data.c_municipio,
        "cnpj": data.c_cnpj !== undefined ? data.c_cnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','').replaceAll('_','') : '',
        "estado": data.c_uf == undefined ? "" : data.c_uf
      });   
      // console.log(raw);
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };  
      fetch(`${URLBunge}/api/Merchandising/ListarMerchandising`, requestOptions)
        .then(response => response.json())
        .then(result => {
          console.log(result);
          if(result.sucesso === true) {
            setDadosMerchandising(result.listaMerchandising);
            setCarregandoBusca(false);  
            setTextoAguarde(false);
          } else {
            setCarregandoBusca(false);
            setTextoAguarde(false);
          }
        })
        .catch(error => {console.log('error', error); setTextoAguarde(false) });

  };

  function LoadBusca() {
    return <>
    <div>Carregando...</div>
    </>
  }

  function FecharBuscaCliente() {
    setMostraResultados(false);
    setCarregandoBusca(true);
    setDadosMerchandising([]);
  }

  function DadosMerchan(texto1, texto2) {
    return <>
      <div className={'CNPJSAP'}>
        <span style={{width: 'auto', marginRight: 7}}>{texto1}</span>
        {texto2}
      </div>
    </>
  }

  function DiaSemana(texto1) {
    return <>
      <div style={{borderRadius: 4, backgroundColor: '#103c55', marginBottom: 5, marginRight: 5, display: 'inline-block'}}>
        <div style={{fontSize:13, color: '#FFFFFF', marginBottom: 0, padding: 3, paddingLeft: 7, paddingRight: 7}}>{texto1}</div>
      </div>
    </>
  }

  const renderItem = ( item, index ) => (
    <ItemListaBusca style={{cursor: 'default'}} key={index}>
      <div className={'NomeCliente'}>{item.nome_Loja}</div>
      {DadosMerchan('CNPJ', MascaraCNPJ(item.cnpj))}
      {DadosMerchan('SAP', item.codSap)}
      {DadosMerchan('Bandeira', item.bandeira)}
      {DadosMerchan('Cidade', `${item.municipio}, ${item.uf}`)}
      {DadosMerchan('Canal', item.canal)}
      {DadosMerchan('Promotor', item.nome_Promotor)}
      {DadosMerchan('Telefone', item.telefone)}
      {DadosMerchan('Número da rota', item.rota)}
      {DadosMerchan('Frequência de visitas na semana', item.frequencia)}
      
      <div className={'CNPJSAP'} style={{display: 'block'}}><span style={{width: 'auto'}}>{'Quais dias da semana vai ocorrer a visita'}</span></div>
      {item.segunda !== null ? DiaSemana(item.segunda) : null }
      {item.terca !== null ? DiaSemana(item.terca) : null }
      {item.quarta !== null ? DiaSemana(item.quarta) : null }
      {item.quinta !== null ? DiaSemana(item.quinta) : null }
      {item.sexta !== null ? DiaSemana(item.sexta) : null }
      {item.sabado !== null ? DiaSemana(item.sabado) : null }
    </ItemListaBusca>
  );

  function MostrarResultados(props) {
    return <>
        <BgModal>
        <ModalEvento>
            <div className={'TituloEvento'}>Informações do atendimento</div><Clear />
            <div className={'ListaClientes'} style={{textAlign: 'left'}}>
                <>                    
                    {CarregandoBusca == true ?
                    <LoadBusca />
                    :
                    DadosMerchandising.length > 0 ?
                    DadosMerchandising.map((item, index) => {
                            return renderItem(item, index)
                        })
                    :
                    <div>Nenhum cliente encontrado<br/>Verifique sua busca e tente novamente.</div>
                    }
                </>
            </div>
            <a className={'BtFecharModal'} onClick={()=>FecharBuscaCliente()}>FECHAR</a>
        </ModalEvento>
        </BgModal>
    </>
  }

  function ListarUF(){

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
  
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    
    fetch(`${URLBunge}/api/Merchandising/ListarUF`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result.sucesso === true) {
          for(let i = 0; i < result.ufs.length; i = i + 1 ) {
            setEstados(Estados => [...Estados, {
              value: result.ufs[i],
              label: result.ufs[i]
            }])
          }
        }
      })
      .catch(error => console.log('error', error));

  }

  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>

            { MostraResultados == true ? <MostrarResultados /> : null }
            
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                  <TitNoticias>Merchandising</TitNoticias>
                  <Clear />

                  <TextoDescPesquisa>Roteiro de atendimento dos promotores.</TextoDescPesquisa>
                  <Clear />

                  <BtVoltar onClick={()=>history.push({ pathname: '/home', state: { } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                    <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                  </BtVoltar>

                    <FormPesquisa onSubmit={handleSubmit(onSubmit)}>

                        <DescCampo>Qual o cliente?</DescCampo>
                        
                        <CampoFormCadastro>
                            <Controller
                                control={control}
                                ref={register}
                                id="c_bandeira"
                                name="c_bandeira"
                                type="text"
                                placeholder={'Bandeira'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask=""
                            />
                        </CampoFormCadastro>

                        <CampoFormCadastro>
                            <Controller
                                control={control}
                                ref={register}
                                id="c_municipio"
                                name="c_municipio"
                                type="text"
                                placeholder={'Município'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask=""
                            />
                        </CampoFormCadastro>

                        <CampoFormCadastro>
                            <Controller
                                control={control}
                                ref={register}
                                id="c_cnpj"
                                name="c_cnpj"
                                type="text"
                                placeholder={'CNPJ'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask="99.999.999/9999-99"
                            />
                        </CampoFormCadastro>

                        <CampoFormCadastro>
                          <select name={"c_estado"} id={"c_estado"} ref={register}>
                            <option value={0} disabled selected>UF</option>
                            {
                              Estados.map((item, index) => {
                                return <> <option value={item.value}>{item.label}</option> </>
                              })
                            }
                          </select>
                        </CampoFormCadastro>

                        <Clear />
                        { TextoAguarde === false ?
                            <BotaoEnviarPesquisa type="submit">FILTRAR</BotaoEnviarPesquisa>
                        :
                            <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
                        }

                        <Clear />
                        
                    </FormPesquisa>
                    
                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default Merchandising;
